import React, { useEffect, Fragment } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Form, } from 'reactstrap';
import { mapValues, isFunction, } from 'lodash';
import { useToggle } from 'react-use';

import useFormState from '../hooks/useFormState';
import usePrevious from '../hooks/usePrevious';
import Field from '../Field';

const { entries, } = Object;

export default function ModelFormModal(props) {
  const { fields, title, isOpen, values, onClickClose, onStateChanged = _ => _, submitLabel = '保存', headerClassName = '', renderFormHeader = _ => null, renderFormBody = _ => _, renderFooterContent = _ => _, fieldProps = _ => null, } = props;
  const statedFields = useFormState(values, isFunction(fields) ? fields() : fields, isOpen);
  const prevStatedFields = usePrevious(statedFields);
  const isUnsubmittable = Object.values(statedFields).some(_ => !_.isValid);
  const [isSubmitting, toggleSubmitting] = useToggle(false);
  const onSubmit = async (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;

    toggleSubmitting(true);
    await props.onSubmit({ ...mapValues(statedFields, 'value'), }, { onClickClose });
    toggleSubmitting(false);
  };
  useEffect(() => {
    onStateChanged(prevStatedFields, statedFields);
  }, [...Object.values(mapValues(statedFields, 'value'))]);

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader className={headerClassName}>
        {title}
      </ModalHeader>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          {renderFormHeader(statedFields, prevStatedFields)}
          {
            renderFormBody((
              <Fragment>
                {
                  entries(statedFields).map(([fieldName, fieldSetting]) => (
                    <Field
                      key={fieldName}
                      name={fieldName}
                      {...fieldSetting}
                      {...fieldProps(fieldName, fieldSetting)}
                    />
                  ))
                }
              </Fragment>
            ))
          }
        </ModalBody>
        <ModalFooter>
          {
            renderFooterContent((
              <Fragment>
                {onClickClose && <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>}
                <Button className="save" type="submit" color="primary" onClick={onSubmit} disabled={isUnsubmittable || isSubmitting}>{submitLabel}</Button>
              </Fragment>
            ), { onSubmit, onClickClose, isUnsubmittable, isSubmitting, })
          }
        </ModalFooter>
      </Form>
    </Modal>
  );
};
